module.exports = __webpack_public_path__ + "static/media/lizinde_kagarama5.d4ad38af.jpeg";